import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';

export const getTemplateSchedulersForCompany = async ({
  companyId,
  showActive,
  showMine,
  token,
}: APIRequest<{
  companyId: number;
  showActive: boolean;
  showMine: boolean;
}>): APIResponsePromise =>
  await _callBackend(
    '/template_schedulers/get_template_schedulers_for_company',
    'POST',
    { company_id: companyId, show_active: showActive, show_mine: showMine },
    token,
  );

export const deleteTemplateScheduler = async ({
  templateSchedulerId,
  token,
}: APIRequest<{
  templateSchedulerId: number;
}>): APIResponsePromise =>
  await _callBackend(
    `/template_schedulers/delete_template_scheduler?id=${templateSchedulerId}`,
    'GET',
    null,
    token,
  );

export const updateTemplateScheduler = async ({
  params,
  token,
}: APIRequest<{
  params: any;
}>): APIResponsePromise =>
  await _callBackend(
    '/template_schedulers/update_template_scheduler',
    'POST',
    { ...params },
    token,
  );
